// The location bar under the panel's header, on a brand with several locations (D4). Wording from the Amigo design's
// copy sheet (Location bar).
export default {
  label: 'Locatie',
  all_one: 'Alle {{count}} locaties',
  all_other: 'Alle {{count}} locaties',
};
